import { apiClient } from "helpers/api_helper";

export const GetDailyReport = async (params: any) => {
    try {
        const query = params.toString();
        if (!params.get("materialTypeId")) {
            // materialTypeId is missing OR empty
            return await apiClient.get(`api/v1/Report/GetDailyReport`);
        }

        return await apiClient.get(`api/v1/Report/GetDailyReport?${query}`);
    } catch (error: any) {
        throw new Error(error.message);
    }
};

